import React, { useCallback, useEffect, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { LuPencilLine } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { deleteClasses, getClasses } from "../../redux/services/classesSlice";
import { useNavigate } from "react-router-dom";
import ConfirmationPage from "../../common/ConfirmationPage";
import Table from "../../common/Table";
import { toast } from "react-toastify";
import { exportToTablePDF } from "../../common/PdfFormat";

const Classes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const [confirm, setConfirm] = useState(false);
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const getClassesData = useSelector((state) => state?.classes?.classesData);
  const getAllClasses = useCallback(async () => {
    try {
      await dispatch(
        getClasses({ page: page + 1, limit: pageLimit, searchData })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllClasses();
  }, [getAllClasses]);

  const deleteClassesData = async () => {
    try {
      const response = await dispatch(deleteClasses(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllClasses();
    } catch (error) {}
  };
  const handleDelete = (questionId) => {
    setItemToDelete(questionId);
    setConfirm(true);
  };
  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => navigate(`/edit-classes?classesId=${row._id}`),
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => handleDelete(row._id),
    },
  ];
  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    { header: "Owner Name", key: "ownerName" },
    { header: "Class Name", key: "name" },
    { header: "Email", key: "email" },
    {
      header: "Contact",
      key: "contact",
      render: (value) => value?.countryCode + " " + value?.mobile,
    },
    { header: "Referral Code", key: "referralCode" },
    {
      header: "Image",
      key: "image",
      render: (value) =>
        value ? (
          <button className="max-w-16 max-h-16 overflow-hidden rounded-xl">
            <img src={value} alt="" className="w-full h-full" />
          </button>
        ) : (
          "—"
        ),
    },
  ];
  const exportToPDF = () => {
    const headersConfig = [
      { label: "S/N", key: "index", render: (_, __, index) => index + 1 },
      {
        label: "Owner Name",
        key: "ownerName",
        render: (_,row) => row?.ownerName || "-",
      },
      {
        label: "Class Name",
        key: "name",
        render: (_,row) => row?.name || "-",
      },
      { label: "Email", key: "email", render: (_,row) => row?.email || "-" },
      {
        label: "Contact",
        key: "contact",
        render: (_,row) => row?.contact?.countryCode + " " + row?.contact?.mobile,
      },
      {
        label: "Referral Code",
        key: "referralCode",
        render: (_,row) => row?.referralCode || "-",
      },
    ];    
    const data = getClassesData?.classes_data || [];
    exportToTablePDF({
      tableName: "Classes Data",
      data,
      headersConfig,
      pdfName: "classes_data.pdf",
    });
  };

  return (
    <>
      <Table
        title="Classes"
        buttonTitle="Add Classes"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => navigate("/add-classes")}
        columns={columns}
        data={getClassesData?.classes_data}
        actions={actions}
        pageCount={getClassesData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        exportButton={true}
        onExport={exportToPDF}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Classes"
          confirm={confirm}
          onDelete={deleteClassesData}
          onCancel={() => setConfirm(false)}
        />
      )}
    </>
  );
};

export default Classes;
